// GN: botão do WhatsApp com captura de contato (nome, WhatsApp, e-mail) antes de abrir a conversa.
if (!customElements.get('gn-whatsapp')) {
  customElements.define(
    'gn-whatsapp',
    class GnWhatsapp extends HTMLElement {
      static CHAVE = 'gn-whatsapp-contato';

      connectedCallback() {
        this.janela = this.querySelector('dialog');
        this.form = this.querySelector('.gn-whatsapp__form');
        this.erro = this.querySelector('.gn-whatsapp__erro');
        this.querySelector('.gn-whatsapp__botao').addEventListener('click', () => this.abrir());
        // Outros botões de WhatsApp do site (ex.: rodapé) abrem o mesmo pop-up: basta o atributo data-gn-whatsapp.
        document.addEventListener('click', (e) => {
          if (!e.target.closest?.('[data-gn-whatsapp]')) return;
          e.preventDefault();
          this.abrir();
        });
        this.form.addEventListener('submit', (e) => this.enviar(e));
        this.form.whatsapp.addEventListener('input', (e) => (e.target.value = this.mascara(e.target.value)));
        this.janela.addEventListener('click', (e) => e.target === this.janela && this.janela.close());
        window.addEventListener('pageshow', () => {
          this.form.querySelector('.gn-whatsapp__enviar').disabled = false;
        });
      }

      lerContato() {
        try {
          return JSON.parse(localStorage.getItem(GnWhatsapp.CHAVE));
        } catch (e) {
          return null;
        }
      }

      abrir() {
        const contato = this.lerContato();
        if (contato?.nome) return this.irParaWhatsapp(contato.nome);
        this.janela.showModal();
        this.form.nome.focus();
      }

      mascara(valor) {
        const d = valor.replace(/\D/g, '').slice(0, 11);
        if (d.length <= 2) return d.length ? `(${d}` : '';
        if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
        if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
        return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
      }

      validar({ nome, whatsapp, email }) {
        if (nome.trim().length < 2) return 'Informe seu nome.';
        const digitos = whatsapp.replace(/\D/g, '');
        if (digitos.length < 10 || digitos.length > 11) return 'Informe um WhatsApp válido com DDD.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return 'Informe um e-mail válido.';
        return '';
      }

      async enviar(evento) {
        evento.preventDefault();
        const dados = {
          nome: this.form.nome.value.trim(),
          whatsapp: this.form.whatsapp.value.trim(),
          email: this.form.email.value.trim(),
          pet: this.form.pet?.value.trim() || '',
          aceita_whatsapp: !!this.form.aceita_whatsapp?.checked,
        };
        const problema = this.validar(dados);
        this.erro.hidden = !problema;
        this.erro.textContent = problema;
        if (problema) return;

        const botao = this.form.querySelector('.gn-whatsapp__enviar');
        botao.disabled = true;

        const registro = {
          ...dados,
          whatsapp_digitos: '55' + dados.whatsapp.replace(/\D/g, ''),
          pagina: this.dataset.pagina || location.href,
          origem: 'site-gn-foods',
          data: new Date().toISOString(),
        };

        // Quem deixa o contato também ganha o cupom de primeira compra (exceto CEP fora da área).
        const cupom = window.gnLiberarCupomPrimeiraCompra?.(dados.nome);
        if (cupom) await Promise.race([cupom, new Promise((resolve) => setTimeout(resolve, 1500))]);

        // Planilha/integração: envia ao webhook configurado (ex.: Google Apps Script, Make, Zapier).
        if (this.dataset.webhook) {
          try {
            await Promise.race([
              fetch(this.dataset.webhook, {
                method: 'POST',
                mode: 'no-cors',
                headers: { 'Content-Type': 'text/plain;charset=utf-8' },
                body: JSON.stringify(registro),
              }),
              new Promise((resolve) => setTimeout(resolve, 2500)),
            ]);
          } catch (e) {
            // Não bloqueia o atendimento se a integração falhar.
          }
        }

        try {
          localStorage.setItem(GnWhatsapp.CHAVE, JSON.stringify({ nome: dados.nome, pet: dados.pet, data: registro.data }));
        } catch (e) {}

        document.dispatchEvent(new CustomEvent('gn:whatsapp-lead', { detail: registro }));
        this.irParaWhatsapp(dados.nome);
        // Se o cliente voltar ao site (botão voltar), o botão não fica travado.
        setTimeout(() => (botao.disabled = false), 1500);
      }

      irParaWhatsapp(nome) {
        const texto = (this.dataset.mensagem || '').replace('{nome}', nome || '');
        const url = `https://wa.me/${this.dataset.numero}${texto ? `?text=${encodeURIComponent(texto)}` : ''}`;
        if (this.janela.open) this.janela.close();
        window.location.href = url;
      }
    }
  );
}
